import { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../redux/hook";
import { showForgetPassword } from "../redux/actions";

export const useForgetPassword = () => {
  const dispatch = useAppDispatch();

  const loadingResetPassword = useAppSelector(
    (state) => state.userReducer.loadingResetPassword
  );

  const handleShowForgetPassword = useCallback(
    (show: boolean) => {
      dispatch(showForgetPassword(show));
    },
    [dispatch]
  );

  return {
    loadingResetPassword,
    handleShowForgetPassword,
  };
};
